<template>
  <users-mobile-index v-if="screenSize === 'mobile'" />
  <users-table v-else />
</template>

<script type="text/javascript">
import UsersMobileIndex from '@/views/common/UsersMobileIndex.vue';
import UsersTable from '@/views/common/tables/UsersTable.vue';

export default {
  name: 'Users Index',
  components: {
    UsersMobileIndex,
    UsersTable,
  },
  props: {
    screenSize: String,
  },
};
</script>
